import { create } from 'zustand';

interface PromiseState {
  promises: { key: string; p: Promise<any> }[];
  exec: <T>(key: string, fn: () => Promise<T>) => Promise<T>;
}

export const usePromiseStore = create<PromiseState>((set, get) => ({
  promises: [],
  exec: async <T>(key: string, fn: () => Promise<T>): Promise<T> => {
    const existing = get().promises.find(item => item.key === key)?.p;
    if (existing) return existing;

    const p = fn();
    set(state => ({ promises: [...state.promises, { key: key, p: p }] }));
    return p;
  },
}));
